<template>
    <div>
        <stats :show-headline="false" :show-grid="true" :grid-cols="5">
            <stat :name="quantityLabel || $t('shared.pyramid_auction.levels_overview.quantity')"
                  :value="quantity"
                  :same-width="true"/>
            <stat v-if="!hideAvailableQuantity"
                  :name="$t('shared.modals.adjust_quantity_modal.adjust_overview.available')"
                  :value="availableQuantity"
                  :same-width="true"/>
            <stat :name="$t('shared.pyramid_auction.levels_overview.shop_price' + this.$page.props.tenant.labels_key)"
                  :value="shopPrice | toCurrency"
                  :same-width="true"/>
            <stat :name="$t('shared.pyramid_auction.levels_overview.max_price')"
                  :value="maxPrice | toCurrency"
                  :same-width="true"/>
            <stat :name="$t('shared.pyramid_auction.levels_overview.min_price')"
                  :value="minPrice | toCurrency "
                  :same-width="true"/>
            <stat :name="$t('shared.pyramid_auction.levels_overview.levels')"
                  :value="levels"
                  :same-width="true"/>
        </stats>
    </div>
</template>

<script>
import { Link } from '@inertiajs/vue2';
import Stat from "../Stat";
import Stats from "../Stats";

export default {
    components: {
        Link,
        Stats,
        Stat
    },
    props: {
        quantity: Number,
        quantityLabel: {
            type: String,
            default: null
        },
        maxPrice: Number,
        minPrice: Number,
        levels: Number,
        shopPrice: Number,
        availableQuantity: Number,
        hideAvailableQuantity: Boolean
    },
}
</script>
